import { useQuery } from '@tanstack/react-query';
import { inventoryService } from '@/services';
import { queryKeys } from '@/services/query-keys';

export const useInventoryStates = () => {
  return useQuery({
    queryKey: queryKeys.inventory.states(),
    queryFn: () => inventoryService.getInventoryStates(),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

